import Accordion from "./TagAccordion.vue"
export default Accordion
